export const LEGAL_NAME_MIN_LENGTH = 5;
